var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDangerIconLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 91,
    viewBox: "0 0 102 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0794 7.29057L99.8271 71.067C100.636 72.9707 100.99 74.5186 101.091 76.1267C101.293 79.8838 99.9788 83.5358 97.4009 86.3461C94.823 89.1465 91.3352 90.7996 87.5442 91H13.5433C11.9764 90.9048 10.4094 90.5491 8.94357 89.9981C1.61425 87.0425 -1.92405 78.7266 1.05823 71.5179L38.0587 7.24549C39.3223 4.98618 41.2431 3.03747 43.6188 1.78509C50.4932 -2.02717 59.2379 0.477595 63.0794 7.29057ZM54.9415 49.3136C54.9415 51.7182 52.9702 53.727 50.5439 53.727C48.1176 53.727 46.0958 51.7182 46.0958 49.3136V35.1416C46.0958 32.732 48.1176 30.7833 50.5439 30.7833C52.9702 30.7833 54.9415 32.732 54.9415 35.1416V49.3136ZM50.5439 70.8702C48.1176 70.8702 46.0958 68.8614 46.0958 66.4618C46.0958 64.0522 48.1176 62.0484 50.5439 62.0484C52.9702 62.0484 54.9415 64.0071 54.9415 66.4067C54.9415 68.8614 52.9702 70.8702 50.5439 70.8702Z",
    fill: "#F64040"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerIconLarge);
export default __webpack_public_path__ + "static/media/dangerIconLarge.a80eeb3bb6db71a62b79966d5e9840af.svg";
export { ForwardRef as ReactComponent };